import React, { useState } from 'react';
import Link from 'components/Link';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './TOIAssistBannerWidget.scss';

const TOIAssistBannerWidget = props => {
  if (!(props.data && props.data.text)) {
    return null;
  }

  const { data } = props;
  const [hideWidget, setHideWidget] = useState(false);

  if (hideWidget) {
    return null;
  }

  const bodystruct = {
    version: 'website_25Jul2023',
    type: 'redirect',
  };

  const slot_name = 'toi_hp_top_breakingnews_widget';

  const sendClickGrx = e => {
    if (e.target.classList.contains('close_btn')) {
      e.preventDefault();
      return false;
    }
    setTimeout(() => {
      analyticsWrapper('grx', 'track', 'TOIAssist_WidgetClick', {
        slot_name,
        body: JSON.stringify(bodystruct),
      });
    }, 3000);
    return true;
  };

  return (
    <InViewObserver
      inViewCallback={() => {
        setTimeout(() => {
          analyticsWrapper('grx', 'track', 'TOIAssist_WidgetView', {
            slot_name,
            body: JSON.stringify(bodystruct),
          });
        }, 5000);
      }}
    >
      <Link
        to={`https://www.timesassist.com/?refer_type=${
          props.isWapView ? 'mweb' : 'web'
        }&refer_template=homepage`}
        target="_blank"
        onClick={sendClickGrx}
        className={`${s.bannerWrapper} ${
          data.theme === 'green' ? s.greenTheme : ''
        }`}
      >
        <div className={s.lhsWrapper}>
          <div className={s.launchButton}>New Launch</div>
          <div className={s.tatbText}>{data.text}</div>
        </div>
        <div className={s.rhsWrapper}>
          <div className={s.clickButton}>Click</div>
          <div
            className={`${s.closeBtn} close_btn`}
            onClick={() => {
              setHideWidget(true);
            }}
          />
        </div>
      </Link>
    </InViewObserver>
  );
};

export default TOIAssistBannerWidget;
